import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { TrashIcon } from "../../../assets/images/TrashIcon";
import { DeleteInvitationModal } from "./DeleteInvitationModal/DeleteInvitationModal";
import { TokenCell } from "./TokenCell/TokenCell";
import { StatusBadge } from "../../common/Table/StatusBadge/StatusBadge";
import { ActionButton } from "../../common/Table/ActionButton/ActionButton";
import { Table } from "../../common/Table/Table";
export const InvitationsTable = ({ invitations, isLoading, onDelete }) => {
  const { t } = useTranslation();
  const [deleteModal, setDeleteModal] = useState({
    isOpen: false,
    invitationId: null,
    invitationToken: "",
  });

  const handleOpenDeleteModal = (id, token) => {
    setDeleteModal({
      isOpen: true,
      invitationId: id,
      invitationToken: token,
    });
  };

  const handleCloseDeleteModal = () => {
    setDeleteModal({
      isOpen: false,
      invitationId: null,
      invitationToken: "",
    });
  };

  const handleConfirmDelete = async () => {
    const result = await onDelete(deleteModal.invitationId);
    if (result.success) {
      handleCloseDeleteModal();
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    return new Date(dateString).toLocaleDateString();
  };

  const getStatus = (invitation) => {
    if (invitation.expires_at && new Date(invitation.expires_at) < new Date()) {
      return "expired";
    }

    if (invitation.max_uses && invitation.times_used >= invitation.max_uses) {
      return "fulfilled";
    }

    return "active";
  };

  const columns = [
    { key: "token", header: t("invitations.token") },
    {
      key: "organization_name",
      header: t("invitations.organization"),
      width: "150px",
      wrap: true,
    },
    { key: "role", header: t("invitations.role"), width: "155px" },
    { key: "status", header: t("common.status") },
    { key: "times_used", header: t("invitations.usageCount") },
    { key: "max_uses", header: t("invitations.maxUses") },
    { key: "created_at", header: t("invitations.createdAt") },
    { key: "expires_at", header: t("invitations.expiresAt") },
    { key: "created_by", header: t("invitations.createdBy"), width: "190px" },
    { key: "actions", header: t("common.actions") },
  ];

  const renderCustomCell = (item, key, column) => {
    switch (key) {
      case "token":
        return (
          <TokenCell
            token={item.token}
            copyText={t("common.copy")}
            copiedText={t("common.copied")}
          />
        );
      case "role":
        return t(`roles.${item.role || "user"}`);
      case "status": {
        const status = getStatus(item);
        return <StatusBadge status={status} text={t(`common.${status}`)} />;
      }
      case "created_at":
      case "expires_at":
        return formatDate(item[key]);
      case "times_used":
        return item.times_used || 0;
      case "max_uses":
        return item.max_uses || 1;
      case "actions": {
        return (
          <ActionButton
            onClick={() => handleOpenDeleteModal(item.id, item.token)}
            ariaLabel={t("invitations.deleteInvitation")}
          >
            <TrashIcon />
          </ActionButton>
        );
      }
      default:
        return item[key] || "-";
    }
  };

  return (
    <>
      <Table
        columns={columns}
        data={invitations}
        emptyMessage={t("invitations.noInvitationsFound")}
        loadingMessage={t("invitations.loadingInvitations")}
        isLoading={isLoading}
        renderCustomCell={renderCustomCell}
      />

      <DeleteInvitationModal
        isOpen={deleteModal.isOpen}
        onClose={handleCloseDeleteModal}
        onConfirm={handleConfirmDelete}
        token={deleteModal.invitationToken}
      />
    </>
  );
};

export default InvitationsTable;
